<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="">
          <!-- Create Rates -->
          <b-button
            v-if="selectedCard == 'rates'"
            variant="outline-primary"
            @click="$refs.routesTable.addRate()"
          >
            {{ $t("Add rate").toUpperCase() }}
          </b-button>

          <!-- Creaite Routes -->
          <b-button
            v-if="selectedCard == 'routes'"
            variant="outline-primary"
            @click="$refs.routesTable.addRoute()"
          >
            {{ $t("Add route").toUpperCase() }}
          </b-button>

          <!-- Creates Zones -->
          <b-button
            v-if="selectedCard == 'zones'"
            variant="outline-primary"
            @click="$refs.routesTable.addZone()"
          >
            {{ $t("Add zone").toUpperCase() }}
          </b-button>
          <b-button v-if="selectedCard == 'locations'" variant="outline-primary" @click="$refs.routesTable.locationsCode()">
            {{ $t("Locations code") }}
          </b-button>
          <!-- <b-button
            v-if="currentTab == 'area'"
            @click="$refs['routerViewTab'].newArea()"
            v-t="'CREATE'"
            variant="outline-success"
          ></b-button> -->
        </div>
      </template>
    </header-slot>
    <!-- <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) | capitalize }}
      </b-nav-item>
    </b-nav> -->
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view
        ref="routesTable"
        @changeSelectedCard="changeSelectedCard"
        :key="routeName"
      />
    </b-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedCard: "rates",
    };
  },
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    currentTab() {
      return this.$route.meta.tab;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    changeSelectedCard(card) {
      this.selectedCard = card;
    },
  },
};
</script>